module.exports = __webpack_public_path__ + "static/media/Brothas_Express_Logo.605de1ad.png";